/*
PROV: COHINT037.BF.UITYPE
REQ: AUD-UX-10, AUD-UX-11, SYS-ARCH-15, UX-BASE-05
WHY: Shared typography primitives so headings/body text are consistent across apps.
*/

import React from "react";

type CommonProps = {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

import { cn } from "./lib/utils";

const H1_TEXT = "font-sans text-[18px] font-bold leading-[1.25] text-[rgb(var(--cohorta-text))]";
const H2_TEXT = "font-sans text-[16px] font-bold leading-[1.25] text-[rgb(var(--cohorta-text))]";
const B1_TEXT = "font-sans text-[14px] font-medium leading-[1.45] text-[rgb(var(--cohorta-text-muted))]";
const B2_TEXT = "font-sans text-[12px] font-medium leading-[1.45] text-[rgb(var(--cohorta-text-muted))]";
const SB1_TEXT = B2_TEXT;

export function h1TextClassName(extra?: string) {
  return cn(H1_TEXT, extra);
}

export function h2TextClassName(extra?: string) {
  return cn(H2_TEXT, extra);
}

export function b1TextClassName(extra?: string) {
  return cn(B1_TEXT, extra);
}

export function b2TextClassName(extra?: string) {
  return cn(B2_TEXT, extra);
}

// SB1 ("sub header") is B2 used directly under an H1/H2 title with no ad-hoc spacing.
export function sb1TextClassName(extra?: string) {
  return cn(SB1_TEXT, extra);
}

export function H1({ children, className, style }: CommonProps) {
  return (
    <h1
      className={cn("m-0", H1_TEXT, className)}
      style={style}
    >
      {children}
    </h1>
  );
}

export function H2({ children, className, style }: CommonProps) {
  return (
    <h2
      className={cn("m-0", H2_TEXT, className)}
      style={style}
    >
      {children}
    </h2>
  );
}

export function H3({ children, className, style }: CommonProps) {
  return (
    <h3 className={cn("m-0", H2_TEXT, className)} style={style}>
      {children}
    </h3>
  );
}

export function BodyText({ children, className, style }: CommonProps) {
  return (
    <p className={cn("m-0", B1_TEXT, className)} style={style}>
      {children}
    </p>
  );
}

export function Muted({ children, className, style }: CommonProps) {
  return (
    <p
      className={cn("m-0", B2_TEXT, className)}
      style={style}
    >
      {children}
    </p>
  );
}

export function SB1({ children, className, style }: CommonProps) {
  return (
    <p className={cn("m-0", SB1_TEXT, className)} style={style}>
      {children}
    </p>
  );
}
